import { useCallback, useEffect } from 'react';
import { CallIntelligenceEventType } from '@weave/schema-gen-ts/dist/shared/call-intelligence/notification/enums.pb';
import { CallIntelBackfillEventPayload } from '@weave/schema-gen-ts/dist/shared/call-intelligence/notification/message.pb';
import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { CallIntelligenceWetags } from '@wetags/call-intelligence';
import { useQueryClient } from 'react-query';
import { CallIntelligenceV2, CallIntelPLGServiceName } from '@frontend/api-call-intel';
import { useWebsocketEventPublisher } from '@frontend/websocket';
import { BACKFILL_WETAG } from '../constants';

export const useBackfillWebsocketSubscription = () => {
  const queryClient = useQueryClient();
  const publisher = useWebsocketEventPublisher();

  const [isWetagEnabled] = CallIntelligenceWetags.useWetag(BACKFILL_WETAG);

  const handleBackfillEvent = useCallback(
    (event: { params: CallIntelBackfillEventPayload }) => {
      const { eventType } = event.params;

      if (
        eventType !== CallIntelligenceEventType.CALL_INTELLIGENCE_EVENT_TYPE_TRIAL_BACKFILL_BATCH1_READY &&
        eventType !== CallIntelligenceEventType.CALL_INTELLIGENCE_EVENT_TYPE_TRIAL_BACKFILL_FULLY_COMPLETE &&
        eventType !== CallIntelligenceEventType.CALL_INTELLIGENCE_EVENT_TYPE_TRIAL_BACKFILL_WAITING_FOR_LIVE_CALLS
      ) {
        return;
      }

      // Invalidate all call-intel queries
      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return (
            Array.isArray(key) && (key[0] === CallIntelligenceV2.serviceName || key[0] === CallIntelPLGServiceName)
          );
        },
      });
    },
    [queryClient]
  );

  useEffect(() => {
    if (!isWetagEnabled) return;

    publisher.on(NotificationType.CALL_INTELLIGENCE_BACKFILL, handleBackfillEvent);
    return () => {
      publisher.off(NotificationType.CALL_INTELLIGENCE_BACKFILL, handleBackfillEvent);
    };
  }, [isWetagEnabled, publisher, handleBackfillEvent]);
};
